import { Routes, Route } from 'react-router-dom';
import MainContent from '../MainContent/MainContent';
import HomeContent from '../MainContent/Home/HomeContent';
import AttendanceView from '../MainContent/AttendanceView/AttendanceView';
// import ElectiveSelector from '../MainContent/ElectiveSubject/ElectiveSubject';
import CAMarkView from '../MainContent/CAMarkView/CAMarkView';
import HallTicket from '../MainContent/HallTicket/HallTicket';
import ExamResult from '../MainContent/ExamResult/ExamResult';
import ProfileSettings from '../MainContent/ProfileSettings/ProfileSettings';
import Feedback from '../MainContent/Feedback/Feedback';
import NavigateToHome from './NavigateToHome';
import ExamFees from '../MainContent/ExamFees/ExamFees';
import PaymentStatus from '../MainContent/ExamFees/PaymentStatus';
import ExamTimeTable from '../MainContent/TimeTable/TimeTable';
import Curriculum from '../MainContent/CurriculumManagement/Curriculum';

const DashboardRoutes = () => {
  return (
    <Routes>
      <Route element={<MainContent />}>
        <Route path="home" element={<HomeContent />} />
        <Route path="attendance" element={<AttendanceView />} />
        {/* <Route path="Elective" element={<ElectiveSelector />} /> */}
        <Route path="Curriculum" element={<Curriculum />} />
        <Route path="ca-marks" element={<CAMarkView />} />
        <Route path="exam-fees" element={<ExamFees />} />
        <Route path="payment-status" element={<PaymentStatus />} />
        <Route path="exam-timetable" element={<ExamTimeTable />} />
        <Route path="hall-ticket" element={<HallTicket />} />
        <Route path="exam-result" element={<ExamResult />} />
        <Route path="feedback" element={<Feedback />} /> 
        <Route path="profile" element={<ProfileSettings />} /> 
        <Route index element={<HomeContent />} />
        <Route path="*" element={<NavigateToHome />} />
      </Route>
    </Routes>
  );
};

export default DashboardRoutes;